export default __webpack_public_path__ + "static/media/teksan-store-qr.e7157b9d.svg";